module.exports = __webpack_public_path__ + "img/applicable-3.7d903c3f.png";